import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { gql, useQuery } from '@apollo/client';
import clientGraphql from '../../../common/apollo-graphql';
import AuthContext from '../../auth/context/AuthContext';
import ReferralBarChart from './ReferralBarChart';

const REFERRAL_LIST = gql`
  query ReferralList($startDate: String!, $endDate: String!, $type: String) {
    referral_list(start_date: $startDate, end_date: $endDate, type: $type) {
      name
      referrals
    }
  }
`;

export default function ReferralList({ startDate, endDate, type }) {
  const currentUser = useContext(AuthContext);
  const color = type === 'sent' ? '#1abc9c' : '#3498db';

  const { data, loading } = useQuery(REFERRAL_LIST, {
    client: clientGraphql,
    variables: {
      type,
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip: !currentUser,
  });

  const referrals = [...(data?.referral_list || [])].sort((a, b) => b.referrals - a.referrals);

  const totalReferrals = referrals.reduce((sum, r) => sum + r.referrals, 0);

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        Showing data from {startDate.format('MMMM YYYY')} - {endDate.format('MMMM YYYY')}<br />
      </Typography>

      <ReferralBarChart
        referrals={referrals}
        color={color}
        totalLabel={`Referrals (${totalReferrals})`}
        show={!loading && referrals.length > 0}
      />
    </Box>
  );
}
